import React from 'react'
import "./footer.css";
const Footer = () => {
  const currentYear = (new Date()).getFullYear();
  return (
    <div className='footer-main'>
      <h5>© Copyright  {currentYear}. Rabbit and Tortoise Technology Solutions.</h5>
    </div>
  )
}

export default Footer